import $ from 'jquery';
import rivets from 'rivets';
import { updateState } from '../../../../home24/helpers/custom-elements';
import BaseView from '../../../core/baseView';

export default BaseView.extend({

    selectors: {
        formId: '#prevention-form',
        ajaxOverlayId: '#ajaxOverlay',
        statusCheckboxClass: '.js-prevention__status-checkbox',
        quantitySelectClass: '.js-prevention__quantity-select',
        rowClass: '.js-prevention__item-row'
    },

    events: {
        'click .js-prevention__reject': 'onReject',
        'click .js-prevention__accept': 'onAccept',
        'change .js-prevention__status-checkbox': 'onStatusChanged',
        'change .js-prevention__quantity-select': 'onQuantityChanged'
    },

    elements: {
        $form: null,
        $ajaxOverlay: null
    },

    isRivetsBindingInitialized: false,

    initialize: function () {
        this.elements.$form = this.$el.find(this.selectors.formId);
        this.elements.$ajaxOverlay = $(this.selectors.ajaxOverlayId);

        this.model.set('ajaxUrl', this.elements.$form.data('ajaxUrl'));

        this.listenTo(this.model, 'showAjaxOverlay', this.showAjaxOverlay);
        this.listenTo(this.model, 'hideAjaxOverlay', this.hideAjaxOverlay);
        this.listenTo(this.model, 'change', this.setupRivetsBindings);

    },

    setupRivetsBindings: function () {
        if (!this.isRivetsBindingInitialized) {
            this.isRivetsBindingInitialized = true;

            this.binding = rivets.bind(this.$el, {
                model: this.model
            });
        }
    },

    onAccept: function () {
        this.elements.$form.submit();
    },

    onReject: function (event) {
        event.preventDefault();

        this.elements.$form.find(this.selectors.quantitySelectClass).val(0);
        this.elements.$form.find(this.selectors.statusCheckboxClass).prop('checked', false);
        updateState();

        this.elements.$form.submit();
    },

    onStatusChanged: function (event) {
        var $checkbox = $(event.currentTarget);
        var $quantitySelect = $checkbox.parents(this.selectors.rowClass).find(this.selectors.quantitySelectClass);

        if ($checkbox.prop('checked')) {
            $quantitySelect.val($quantitySelect.find('option').last().val());
        } else {
            $quantitySelect.val(0);
        }

        this.model.sendForm(this.elements.$form.serialize());
    },

    onQuantityChanged: function (event) {
        var $select = $(event.currentTarget);
        var $statusCheckbox = $select.parents(this.selectors.rowClass).find(this.selectors.statusCheckboxClass);

        $statusCheckbox.prop('checked', $select.val() !== '0');

        updateState();
        this.model.sendForm(this.elements.$form.serialize());
    },

    showAjaxOverlay: function () {
        this.elements.$ajaxOverlay.show();
    },

    hideAjaxOverlay: function () {
        this.elements.$ajaxOverlay.hide();
    }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/pages/myAccount/prevention/PreventionView.js
 **/